import React from 'react';
import { useState } from "react";
import { motion } from "framer-motion";
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Divider from '@mui/material/Divider';

function Magnet() {
    const [bugreport, setBugreport] = useState("");
    const [message, setMessage] = useState([]);

    let handleSubmit = async (e) => {
        e.preventDefault();
        try {
          let res = await fetch("https://api.ayo.watch/bug/index.php", {
            method: "POST",
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json'
              // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: JSON.stringify({
                bugreport: bugreport,
            }),
          });
          let resJson = await res.json();
          if (res.status === 200) {
            setMessage({"type": "success", "message": "Magnet added"});
          } else {
            setMessage({"type": "error", "message": "Sorry, this form is currently disabled."});
          }
        } catch (err) {
          setMessage({"type": "error", "message": "Sorry, this form is currently disabled."});
        }
    };

    return (
                <motion.div 
                    className="settings__form__container inner-content-body"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                >
                  <h1>Add Magnet</h1>
                  <p>Add your own magnet links below to convert them to direct download.</p>
                  <div className="settings__form">
                      <h2>Magnet</h2>
                      <Divider variant="middle" />
                      <div className={"message " + message.type}>{message.type ? <p>{message.message}</p> : null}</div>
                      <form onSubmit={handleSubmit}>
                          <FormControl>
                              <TextField
                                  id="outlined-multiline-static"
                                  label="Magnet URL"
                                  multiline
                                  rows={4}
                                  value={bugreport}
                                  onChange={(e) => setBugreport(e.target.value)}
                              />
                              <button type="submit" className="button main">Download</button>
                          </FormControl>
                      </form>
                  </div>
              </motion.div>
    )
}

export default Magnet;